import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { environment } from 'projects/Administration/src/environments/environment';
import * as p from 'public-ip';

@Component({
  selector: 'app-license-key-validation',
  templateUrl: './license-key-validation.component.html'
})
export class LicenseKeyValidationComponent implements OnInit {
  licenseKeyExpirationDate: any;
  isKeyExpired: any;
  @Input() licenseKeyData: any;
  constructor(private activeModal: NgbActiveModal, private userService: UserDataService,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.licenseKeyData) {
      this.licenseKeyExpirationDate = this.licenseKeyData.expirationDate;
      this.isKeyExpired = this.licenseKeyData.isKeyExpired;
    }
  }
  //Close popUp
  OnClose() {
    this.activeModal.dismiss('Cross click');
  }

  logOutUser(): void {
    p.publicIpv4().then((res)=>{
      if(res){
        let baseURL = environment.msalConfig.redirectUri.replace(/\/$/, "");
        let url = baseURL + this.router.url;
        localStorage.removeItem(Constant.UserLoggedId)
        localStorage.removeItem("Theme")
        this.userService.SetLoginActivity(false,res,url).then(
          _response => {
            // This is intentional
          });
      }
    });
  }
}
